import { render, staticRenderFns } from "./InfoBanner.view.vue?vue&type=template&id=5399f02a&"
import script from "./InfoBanner.view.vue?vue&type=script&lang=js&"
export * from "./InfoBanner.view.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev3/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5399f02a')) {
      api.createRecord('5399f02a', component.options)
    } else {
      api.reload('5399f02a', component.options)
    }
    module.hot.accept("./InfoBanner.view.vue?vue&type=template&id=5399f02a&", function () {
      api.rerender('5399f02a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/rearchitected/themes/atmo/views/pages/purchases/item/update/partials/InfoBanner.view.vue"
export default component.exports